import React from 'react';
import { LegalPageLayout } from '@/components/shared/LegalPageLayout';

export default function CookiePolicyPage() {
  return (
    <LegalPageLayout title="Cookie Policy" lastUpdated="January 15, 2025">
      <div className="space-y-8">
        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">1. What Are Cookies</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            Cookies are small text files placed on your device when you visit our website. They help us provide you with a better experience by remembering your preferences, analyzing site usage, and assisting with our marketing efforts.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">2. Types of Cookies We Use</h2>

          <h3 className="font-heading text-sm font-semibold text-foreground mb-2">2.1 Essential Cookies</h3>
          <p className="text-sm text-muted-foreground font-body leading-relaxed mb-4">
            These cookies are necessary for the website to function properly. They enable core features like secure login, session management, and account access. You cannot opt out of essential cookies as they are required for the basic functionality of our platform.
          </p>

          <h3 className="font-heading text-sm font-semibold text-foreground mb-2">2.2 Analytics Cookies</h3>
          <p className="text-sm text-muted-foreground font-body leading-relaxed mb-4">
            We use analytics cookies to understand how visitors interact with our website. This includes page visits, time spent on pages, bounce rates, and navigation paths. We use this data to improve our website and user experience. Analytics data is collected in aggregate and does not personally identify you.
          </p>

          <h3 className="font-heading text-sm font-semibold text-foreground mb-2">2.3 Functional Cookies</h3>
          <p className="text-sm text-muted-foreground font-body leading-relaxed mb-4">
            Functional cookies remember your preferences such as language, region, and display settings. They make your experience more personalized without requiring you to re-configure every visit.
          </p>

          <h3 className="font-heading text-sm font-semibold text-foreground mb-2">2.4 Marketing Cookies</h3>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            These cookies track your activity across websites to deliver relevant advertisements. We may use third-party marketing cookies from advertising partners. You can opt out of marketing cookies without affecting your use of the platform.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">3. Third-Party Cookies</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            Some cookies are placed by third-party services that appear on our pages. These include analytics providers (such as Google Analytics), payment processors, and customer support tools. We do not control these third-party cookies and recommend reviewing their respective privacy policies.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">4. Managing Cookies</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed mb-3">
            You have several options for managing cookies:
          </p>
          <ul className="list-disc list-inside space-y-1.5 text-sm text-muted-foreground font-body ml-2">
            <li>Use your browser settings to block or delete cookies</li>
            <li>Set your browser to alert you when cookies are being set</li>
            <li>Use our cookie preference center to manage non-essential cookies</li>
            <li>Use private/incognito browsing mode</li>
          </ul>
          <p className="text-sm text-muted-foreground font-body leading-relaxed mt-3">
            Please note that disabling certain cookies may impact the functionality of our platform.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">5. Updates to This Policy</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            We may update this Cookie Policy from time to time. Changes will be posted on this page with an updated "Last Updated" date. Continued use of our website after changes constitutes acceptance of the updated policy.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">6. Contact Us</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            If you have any questions about our use of cookies, please contact us at <span className="text-primary">privacy@agentick.com</span>.
          </p>
        </section>
      </div>
    </LegalPageLayout>
  );
}
